<template>
  <div class="offer-row" :class="{fixedFooter:scrolled}">
    <p>
      <img src="./image/discount.png" alt="تخفیف در مادیا">
      تخفیف ویژه جمعه آخر سال شروع شد.
      <b>
        کد تخفیف :
        BF98
      </b>
      <img src="./image/discount.png" alt="offer-madya">
    </p>
  </div>
</template>

<script>
export default {
  name: "offer-row",
  data() {
    return {
      scrolled: true
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    offset(el) {
      if (!el)
        return {
          top: 0,
          left: 0,
          height: 0,
          bottom: 0,
          width: 0
        };
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft,
        height: rect.height,
        bottom: rect.height + rect.top + scrollTop,
        width: rect.width
      };
    },
    handleScroll() {
      let scroll = window.pageYOffset || document.documentElement.scrollTop;
      let top = this.offset(document.querySelector("footer")).top;
      if (scroll + window.innerHeight < top) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import (reference) "../../../assets/css/variable.less";
.offer-row {
  width: 100%;
  //   height: 40px;
  background-color: #fff;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 2px 0;
  border-top: 3px dotted @green;
  //   strong,
  p {
    font-size: 19px;
    font-weight: bold;
    color: #4caf50;
  }
  b {
    color: @blue;
  }
}
.fixedFooter {
  position: fixed;
  bottom: 0;
  z-index: 999;
}
.scale {
  transform: scale(-1, 1);
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/offer-row/index.vue